<template>
    <div class="wp-debug-tool">
        <a-descriptions title="" layout="vertical" bordered>
            <a-descriptions-item label="Product"> {{ getPlanName() }}</a-descriptions-item>
            <a-descriptions-item label="Health Status">
                <a-badge status="success" text="Healthy" v-if="isHealthy" />
                <a-badge status="error" text="Not Healthy" v-else />
            </a-descriptions-item>
            <a-descriptions-item label="Whatsapp Name">{{ getVerifiedName() }}</a-descriptions-item>
            <a-descriptions-item label="Whatsapp Number" :span="3"> {{ getPhoneNumber() }}</a-descriptions-item>

            <a-descriptions-item label="Actions" :span="4">
                <div class="debug-buttons-container">
                    <div class="buttons">
                        <a-button type="primary" ghost @click="sendRequest('getMe')"> GET ME</a-button>
                        <a-button type="primary" ghost @click="sendRequest('getConnectionState')">
                            GET CONNECTION STATE
                        </a-button>
                        <a-button type="primary" ghost @click="sendRequest('getHostNumber')"> GET HOST NUMBER</a-button>
                        <a-button type="primary" ghost @click="sendRequest('getStatus')"> GET STATUS</a-button>
                        <a-button type="danger" ghost @click="sendRequest('kill')"> KILL</a-button>
                        <a-button type="danger" ghost @click="sendRequest('reset')"> RESET</a-button>
                        <a-button type="primary" ghost @click="sendRequest('refresh')"> REFRESH</a-button>
                        <a-button type="primary" ghost @click="sendRequest('syncContacts')"> SYNC CONTACTS</a-button>
                        <a-button type="primary" ghost @click="sendRequest('getWAVersion')"> WA VERSION</a-button>
                        <a-button type="primary" ghost @click="sendRequest('healthCheck')"> HEALTH CHECK</a-button>
                        <a-button type="primary" ghost @click="sendRequest('gc')"> RUN GC</a-button>
                        <a-button type="primary" ghost @click="sendRequest('emitUnreadMessages')">
                            GET UNREAD MESSAGES
                        </a-button>
                    </div>
                    <div class="response">
                        <span class="title">RESPONSE</span>
                        <span class="content" v-if="busy"> Waiting .... </span>
                        <div class="content" v-else>
                            <prism-editor class="my-editor" v-model="response" :highlight="highlighter" readonly />
                        </div>
                    </div>
                </div>
            </a-descriptions-item>
        </a-descriptions>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import _ from "lodash";
import { generateRandomId } from "../../../../utils/session";
import { sendSocketMessage, socketMessageStream } from "../../../../utils/socketStream";
import { filter, take, first, timeout, map } from "rxjs/operators";
import log2 from "../../../../utils/log2";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere
import "prismjs/components/prism-json";
import { highlight, languages } from "prismjs/components/prism-core";

const log = log2("WhatsappDebugTool");
export default {
    name: "WhatsappDebugTool",
    data() {
        return {
            busy: false,
            response: "",
        };
    },
    components: {
        PrismEditor,
    },
    computed: {
        ...mapGetters({
            isHealthy: "whatsapp/isHealthy",
        }),
        ...mapState({
            siteId: (state) => state.site.site._id,
            initialized: (state) => state.whatsapp.info.initialized,
            status: (state) => state.whatsapp.info.status,
            whatsappPlusEnabled: (state) => _.get(state.setting.settings, "whatsapp.plus.enabled", false),
            whatsappPlanExists: (state) =>
                _.get(state.setting.settings, "whatsapp.plus.enabled", false) ||
                _.get(state.setting.settings, "whatsapp.enabled", false),
            me: (state) => state.whatsapp.me,
        }),
    },

    methods: {
        highlighter(code) {
            return highlight(code, languages.json); // languages.<insert language> to return html with markup
        },
        getPlanName() {
            if (this.whatsappPlanExists) {
                if (this.whatsappPlusEnabled) {
                    return "Whatsapp Plus";
                } else {
                    return "Whatsapp";
                }
            }
        },
        getVerifiedName() {
            return _.get(this.me, "verifiedName") || _.get(this.me, "pushname");
        },
        getPhoneNumber() {
            return _.get(this.me, "me.user");
        },
        sendRequest(path) {
            const messageId = generateRandomId(5);
            this.busy = true;
            socketMessageStream
                .pipe(
                    map((x) => {
                        log("socketMessageStream", x);
                        return x;
                    }),
                    filter((x) => {
                        const { cmd, data } = x;
                        log("socket message", { cmd, data });
                        return cmd === "whatsapp_service_response" && data.messageId === messageId;
                    }),
                    timeout(5000),
                    first()
                )
                .toPromise()
                .then(({ data }) => {
                    log("response received", data);
                    const { response, path, success, error } = data;
                    this.response = success ? JSON.stringify(response, null, 2) : error;
                })
                .catch((err) => {
                    console.error(err);
                    this.response = "Request timed out";
                })
                .finally(() => {
                    this.busy = false;
                });

            sendSocketMessage("whatsapp send-request", {
                siteId: this.siteId,
                path,
                messageId,
                payload: {},
            });
        },
    },
    mounted() {
        log("mounted");
    },
};
</script>

<style lang="scss">
.wp-debug-tool {
    min-width: 800px !important;

    .debug-buttons-container {
        width: 100%;
        display: flex;
        gap: 10px;
        min-height: 200px;

        .buttons {
            width: 200px;
            display: flex;
            flex-direction: column;
            gap: 5px;
        }

        .response {
            width: 100%;
            height: auto;
            background-color: #f5f8fb;
            border: 1px solid #d1dfec;
            display: flex;
            position: relative;
            flex-direction: column;

            .title {
                padding: 5px;
                font-weight: 600;
                width: 100%;
                display: flex;
                justify-content: flex-end;
            }

            .content {
                padding: 5px;
                font-weight: 600;
                width: 100%;
                display: flex;
                justify-content: flex-start;
                color: #0e4d73;
            }
        }
    }
}

.debug-tool {
    .ant-modal {
        min-width: 900px !important;
    }
}
</style>
